import { FileTransferFeature, queryClient, useUploadFile } from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { mailKeys } from '../keys';

export function useUploadMailFile() {
  const { t } = useTranslation(['common']);

  return useUploadFile({
    documentType: FileTransferFeature.MailAttachment,
    additionalFormValues: {
      overwrite: 'false',
    },
    mutationOptions: {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: mailKeys.all });
      },
      onError: () => {
        toast.error(t('common:snackbarMessages.errorFailed'));
      },
    },
  });
}
